module.exports = __webpack_public_path__ + "img/oneclose-logo.a63b0e58.png";